import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {environment} from '@environments/environment';
import {HttpClient} from '@angular/common/http';
import {ToastrService} from 'ngx-toastr';

export interface IUxInteractions {
  refreshBalance: boolean;
  refreshListCards: boolean;
  addCreditCard: boolean;
  foundCard: boolean;
  foundCardMessage: any;
}

const defaultUx: IUxInteractions = {
  refreshListCards: false,
  refreshBalance: false,
  addCreditCard: false,
  foundCard: false,
  foundCardMessage: null,
};

export interface ITangoAccountInfo {
  accountIdentifier: string;
  accountNumber: string;
  displayName: string;
  status: string;
  contactEmail: string;
  currentBalance: number;
  createdAt: Date;
  currencyCode: string;
}

export interface ITangoCreditCard {

  accountIdentifier: string;
  accountNumber: string;
  activationDate: Date;
  contactInformation: any;
  createdDate: Date;
  customerIdentifier: string;
  expirationDate: string;
  label: string;
  lastFourDigits: string;
  status: string;
  token: string;

}

// const defaultAccountInfo: ITangoAccountInfo = {
//   currentBalance: 0,
//   currencyCode: 'N/A',
// };

@Injectable({
  providedIn: 'root'
})
export class TangoBalanceService {
  private BASE_URL = environment.apiUrl;

  public uxInterations: BehaviorSubject<IUxInteractions> = new BehaviorSubject<IUxInteractions>(defaultUx);

  public accountInfo: BehaviorSubject<ITangoAccountInfo> = new BehaviorSubject<ITangoAccountInfo>(null);
  public creditCards: BehaviorSubject<ITangoCreditCard[]> = new BehaviorSubject<ITangoCreditCard[]>([]);

  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
  ) {
    this.refreshBalance();
  }

  public refreshBalance() {

    this.uxInterations.next({
      ...this.uxInterations.value,
      refreshBalance: true,
    });

    const url = `${this.BASE_URL}/rewards/adminActions`;
    return this.http.post<any>(url, {
      action: 'getBalance',
      params: {},
    }).subscribe(
      {
        next: response => {
          // console.log(response.data.datas);
          this.accountInfo.next(response.data.datas);

          this.uxInterations.next({
            ...this.uxInterations.value,
            refreshBalance: false,
          });

        },
        // error: err => {
        //   this.refreshing.next(false);
        // },
        complete: () => {
          // this.refreshing.next(false);
        }
      }
    );

  }

  public refreshCreditCards() {

    this.uxInterations.next({
      ...this.uxInterations.value,
      refreshListCards: true
    });

    const url = `${this.BASE_URL}/rewards/adminActions`;
    return this.http.post<any>(url, {
      action: 'listCreditCards',
      params: {},
    }).subscribe(
      {
        next: response => {
          console.log(response.data.datas);
          this.creditCards.next(response.data.datas);
          this.uxInterations.next({
            ...this.uxInterations.value,
            refreshListCards: false
          });

          // this.accountInfo.next(response.data.datas);
          // this.refreshing.next(false);
        },
        // error: err => {
        //   this.refreshing.next(false);
        // },
        complete: () => {
          // this.refreshing.next(false);
        }
      }
    );

  }

  public addCreditCard(params) {

    this.uxInterations.next({
      ...this.uxInterations.value,
      addCreditCard: true
    });

    const url = `${this.BASE_URL}/rewards/adminActions`;
    return this.http.post<any>(url, {
      action: 'addCreditCard',
      params,
    })
      .subscribe(
        {
          next: response => {
            console.log(response.data.datas);

            this.toastr.success(`Credit card ${params?.label} added!`);

            this.refreshCreditCards();

            this.uxInterations.next({
              ...this.uxInterations.value,
              addCreditCard: false
            });

            // this.accountInfo.next(response.data.datas);
            // this.refreshing.next(false);

          },
          // error: err => {
          //   this.refreshing.next(false);
          // },
          complete: () => {
            // this.refreshing.next(false);
          }
        }
      );

  }


  public creditCardUnregisters(creditCardToken) {

    this.uxInterations.next({
      ...this.uxInterations.value,
      addCreditCard: true
    });

    const url = `${this.BASE_URL}/rewards/adminActions`;
    return this.http.post<any>(url, {
      action: 'creditCardUnregisters',
      params: {
        creditCardToken,
      },
    })
      .subscribe(
        {
          next: response => {
            console.log(response.data.datas);

            this.toastr.success(`Credit card ${creditCardToken} unregistred!`);
            this.refreshCreditCards();
            this.uxInterations.next({
              ...this.uxInterations.value,
              addCreditCard: false
            });

          },
          // error: err => {
          //   this.refreshing.next(false);
          // },
          complete: () => {
            // this.refreshing.next(false);
          }
        }
      );

  }

  public creditCardDeposits(creditCardToken: string, amount: number) {

    this.uxInterations.next({
      ...this.uxInterations.value,
      foundCard: true,
      foundCardMessage: null,
    });

    const url = `${this.BASE_URL}/rewards/adminActions`;
    return this.http.post<any>(url, {
      action: 'creditCardDeposits',
      params: {
        creditCardToken,
        amount,
      },
    })
      .subscribe(
        {
          next: response => {
            console.log(response.data.datas);

            this.toastr.success(`Credit card ${creditCardToken} founded with ${amount} USD`);

            this.refreshBalance();

            this.uxInterations.next({
              ...this.uxInterations.value,
              foundCard: false,
              foundCardMessage: response.data.datas,
            });

          },
          // error: err => {
          //   this.refreshing.next(false);
          // },
          complete: () => {
            // this.refreshing.next(false);
          }
        }
      );

  }

}


